import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, dt } from "@/lib/api";
import { PageHeader, Card, Table, StatusBadge, Money } from "@/components/common";

export default function Opname() {
  const [rows, setRows] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.get("/opnames").then((r) => setRows(r.data)); }, []);
  return (
    <div>
      <PageHeader title="Stock opname" sub="Hitung fisik harian/mingguan. Variansi tetap tercatat; penyesuaian stok diposting setelah opname diselesaikan.">
        <Link to="/opname/new" className="inline-flex items-center h-9 px-3 rounded-md bg-slate-900 text-white text-sm font-semibold hover:bg-emerald-700" data-testid="new-opname-button">+ Opname baru</Link>
      </PageHeader>
      <Card>
        <Table testid="opname-table" rows={rows} onRow={(r) => nav(`/opname/${r.id}`)} cols={[
          { h: "Kode", r: (r) => <span className="num text-xs font-semibold text-emerald-700">{r.code}</span> },
          { h: "Lokasi", k: "location_name" }, { h: "Tanggal", k: "date" },
          { h: "Periode", r: (r) => (r.period === "weekly" ? "Mingguan" : "Harian") },
          { h: "Barang", right: true, r: (r) => r.lines.length },
          { h: "Variansi", right: true, r: (r) => r.variance_value == null ? <span className="text-slate-300">–</span> : <Money v={r.variance_value} className="font-semibold" /> },
          { h: "Status", r: (r) => <StatusBadge s={r.status} /> },
          { h: "Oleh", r: (r) => <span className="text-xs">{r.created_by.name} · {dt(r.created_at)}</span> },
        ]} />
      </Card>
    </div>
  );
}
